export default "__VITE_ASSET__0z_qTSjc__"